import { RouteConfig } from "vue-router";

export const RDocumentCardArchivedFiles: RouteConfig = {
  path: "archived",
  component: () =>
    import(
      /* webpackChunkName: "document-card-archived-files" */
      "./VDocumentCardArchivedFiles.vue"
    ),
};
